document.addEventListener("DOMContentLoaded", () => {
  
  if (window.innerWidth < 768) {
    const skincareHero = document.querySelector('.skincare-hero');
    const filterContainer = document.querySelector('.filter-bar-container');
  
    if (skincareHero && filterContainer) {
      const filterClone = filterContainer.cloneNode(true);
      filterClone.classList.add('mobile-filter');
      skincareHero.insertAdjacentElement('afterend', filterClone);
    }
  }

  const steps = ['cleansers', 'hydrate', 'transform', 'protect'];
  let currentStepIndex = 0;

  const selectedProducts = Object.fromEntries(steps.map(step => [step, new Set()]));
  const selectedTags = new Set();

  const checklist = document.getElementById('step-checklist');
  const nextBtn = document.getElementById('next-step');
  const cartBtn = document.getElementById('checkout-btn');
  const discountBanner = document.getElementById('discount-message');
  const controls = document.querySelector('.custom-set-controls');
  const priceBlock = document.querySelector('.controls-total');
  const stepSections = document.querySelectorAll('.step-section');

  const saved = JSON.parse(localStorage.getItem('selectedProducts') || '{}');
  steps.forEach(step => {
    if (Array.isArray(saved[step])) {
      saved[step].forEach(id => selectedProducts[step].add(id));
    }
  });

  function updateChecklist() {
    steps.forEach((step, i) => {
      const li = checklist.querySelector(`li[data-step="${step}"]`);
      const productSpan = li.querySelector(`[data-check="${step}"]`);
      const status = li.querySelector(".step-status");
      const body = li.querySelector(".step-body");

      const titles = Array.from(selectedProducts[step])
        .map(id => {
          const card = document.querySelector(`.product-card[data-product-id="${id}"]`);
          return card?.querySelector('.product-title')?.textContent || '';
        }).filter(Boolean);

      if (titles.length > 0) {
        productSpan.textContent = productSpan.dataset.editText || "Editar";
        productSpan.classList.add('selected');
        status.classList.add('selected');
        body.innerHTML = titles.map(t => `<div>${t}</div>`).join('');
      } else {
        productSpan.textContent = productSpan.dataset.emptyText || "(select product)";
        productSpan.classList.remove('selected');
        status.classList.remove('selected');
        body.innerHTML = `<div class="step-products-placeholder">(ninguno)</div>`;
      }

      li.classList.toggle('active', i === currentStepIndex);
    });

    const totalSelected = steps.reduce((acc, step) => acc + selectedProducts[step].size, 0);
    cartBtn.disabled = totalSelected < 3;

    if (discountBanner) {
      discountBanner.style.display = totalSelected >= 3 ? "block" : "none";
    }

    updateTotalPrice();
    saveToMemory();
  }

  function formatPrice(amount) {
    const formatted = amount.toLocaleString(Shopify.locale || 'es-ES', {
      style: 'currency',
      currency: Shopify.currency.active || 'EUR',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const symbol = formatted.replace(/[\d\s.,]/g, '');
    const number = formatted.replace(/[^\d.,]/g, '').trim();
    return `${symbol}${number}`;
  }

  function updateTotalPrice() {
    const prices = [];

    steps.forEach(step => {
      Array.from(selectedProducts[step]).forEach(id => {
        const el = document.querySelector(`.product-card[data-product-id="${id}"] .price-current`);
        if (el) {
          const raw = el.textContent.replace(/[^\d,.-]/g, '').replace(',', '.');
          const value = parseFloat(raw);
          if (!isNaN(value)) prices.push(value);
        }
      });
    });

    const total = prices.reduce((a, b) => a + b, 0);
    const discount = total * 0.9;

    priceBlock.innerHTML = `
      <span class="total-original">${formatPrice(total)}</span>
      <span class="total-discount">${formatPrice(discount)}</span>
    `;
  }

  function showStep(index) {
    stepSections.forEach((section, i) => {
      section.classList.toggle('active', i === index);
    });
  
    currentStepIndex = index;
  
    const isLastStep = index === steps.length - 1;
    nextBtn.disabled = isLastStep;
  
    updateChecklist();
    updateFilterButtonsVisualState();
    updateVisibleCount(steps[index]);
  
if (window.innerWidth < 768) {
  // Limpiar sliders y títulos móviles anteriores
  checklist.querySelectorAll('.cloned-slider, .mobile-title, .mobile-description').forEach(el => el.remove());

  const step = steps[index];
  const section = document.querySelector(`.step-section[data-step="${step}"]`);
  const originalSlider = section?.querySelector('.product-slider');
  const targetLi = checklist.querySelector(`li[data-step="${step}"]`);
  const h3 = section?.querySelector('h3');
  const p = section?.querySelector('p.step-description');

  if (targetLi && originalSlider) {
    // Clonar y mover título
    if (h3) {
      const titleClone = h3.cloneNode(true);
      titleClone.classList.add('mobile-title');
      targetLi.appendChild(titleClone);
    }

    // Clonar y mover descripción
    if (p) {
      const descClone = p.cloneNode(true);
      descClone.classList.add('mobile-description');
      targetLi.appendChild(descClone);
    }

    // Clonar y mover slider
    const sliderClone = originalSlider.cloneNode(true);
    sliderClone.classList.add('cloned-slider');
    sliderClone.style.display = 'flex';
    targetLi.appendChild(sliderClone);

    // Reasignar listeners
    sliderClone.querySelectorAll('.product-card').forEach(card => {
      const id = card.dataset.productId;
      const step = card.dataset.step;

      if (selectedProducts[step]?.has(id)) card.classList.add('selected');

      card.addEventListener('click', () => {
        if (card.dataset.available === "false") return;

        if (selectedProducts[step].has(id)) {
          selectedProducts[step].delete(id);
          card.classList.remove('selected');
        } else {
          selectedProducts[step].add(id);
          card.classList.add('selected');
        }

        updateChecklist();
      });
    });
  }
}


  }

  function updateFilterButtonsVisualState() {
    document.querySelectorAll('.filter-tag').forEach(btn => {
      const tag = btn.dataset.tag;
      btn.classList.toggle('active', selectedTags.has(tag));
    });
  }

  function updateVisibleCount(step) {
    const section = document.querySelector(`.step-section[data-step="${step}"]`);
    if (!section) return;
  
    const h3 = section.querySelector('h3');
    if (!h3) return;
  
    const cards = document.querySelectorAll(`.product-card[data-step="${step}"]`);
    const visible = Array.from(cards).filter(c => !c.closest('.product-slide').classList.contains('hidden'));
    const count = visible.length;
  
    const span = h3.querySelector('span.visible-count');
    if (span) {
      span.textContent = `(${count})`;
    } else {
      h3.innerHTML += ` <span class="visible-count">(${count})</span>`;
    }
  }


  function filterProductsForStep(step) {
    const cards = document.querySelectorAll(`.product-card[data-step="${step}"]`);
    if (selectedTags.size === 0) {
      cards.forEach(card => card.closest('.product-slide')?.classList.remove('hidden'));
      return;
    }

    cards.forEach(card => {
      const tags = card.dataset.tags?.split(',').map(t => t.trim()) || [];
      const match = [...selectedTags].every(tag => tags.includes(tag));
      card.closest('.product-slide')?.classList.toggle('hidden', !match);
    });
  }

  function saveToMemory() {
    const data = {};
    steps.forEach(step => {
      data[step] = Array.from(selectedProducts[step]);
    });
    localStorage.setItem('selectedProducts', JSON.stringify(data));
  }

  function attachProductCardListeners() {
    document.querySelectorAll('.product-card').forEach(card => {
      const id = card.dataset.productId;
      const step = card.dataset.step;

      if (selectedProducts[step]?.has(id)) card.classList.add('selected');

      card.addEventListener('click', () => {
        if (card.dataset.available === "false") return;

        if (selectedProducts[step].has(id)) {
          selectedProducts[step].delete(id);
          card.classList.remove('selected');
        } else {
          selectedProducts[step].add(id);
          card.classList.add('selected');
        }

        updateChecklist();
      });
    });
  }

  attachProductCardListeners();


    nextBtn.addEventListener('click', () => {
      if (currentStepIndex < steps.length - 1) {
        currentStepIndex += 1; // Asegúrate de actualizar el índice
        showStep(currentStepIndex);
      }
    });

  cartBtn.addEventListener('click', () => {
    const items = [];
    steps.forEach(step => {
      Array.from(selectedProducts[step]).forEach(id => {
        items.push({ id, quantity: 1 });
      });
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    }).then(() => {
      localStorage.removeItem('selectedProducts');
      window.location.href = "/discount/pack-builder?redirect=/checkout";
    });
  });

  document.querySelectorAll('.step-product').forEach(label => {
    label.addEventListener('click', () => {
      const li = label.closest('.step-item');
      const step = li.dataset.step;
      const index = steps.indexOf(step);
      if (index !== -1) {
        currentStepIndex = index; // ¡Esto es clave!
        showStep(index);
      }
    });
  });

  document.querySelectorAll('.filter-tag').forEach(btn => {
    btn.addEventListener('click', () => {
      const tag = btn.dataset.tag;
      if (btn.classList.contains('active')) selectedTags.delete(tag);
      else selectedTags.add(tag);

      updateFilterButtonsVisualState();
      steps.forEach(step => {
        filterProductsForStep(step);
        if (step === steps[currentStepIndex]) updateVisibleCount(step);
      });
    });
  });

  document.querySelectorAll('.slider-btn, .filter-arrow').forEach(button => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.filter-bar-container') || button.closest('.slider-wrapper');
      const target = wrapper.querySelector('.filter-bar-wrapper') || wrapper.querySelector('.product-slider');
      const direction = button.classList.contains('right') ? 1 : -1;
      target.scrollBy({ left: direction * 200, behavior: 'smooth' });
    });
  });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      controls.classList.toggle('fixed-bottom', !entry.isIntersecting);
    });
  });
  observer.observe(controls);

  showStep(currentStepIndex);
  steps.forEach(step => filterProductsForStep(step));
});
